var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fs-1_3 third--text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }